import React, {useState} from "react";
import {
    Datagrid,
    DateField,
    Filter,
    List,
    SelectInput,
    SimpleShowLayout,
    TextField,
    TextInput,
    required,
    BooleanField,
    BooleanInput,
    NumberInput, NumberField, ReferenceInput, ReferenceField, ImageInput, ImageField
} from "react-admin";
import CreateView from "../../components/CreateView";
import EditView from "../../components/EditView";
import ShowView from "../../components/ShowView";
import Emoji from "../../components/Emoji";

const PlanFilter = (props) => (
  <Filter {...props}>
      <TextInput
          label="sku"
          source={"sku"}
      />
  </Filter>
);

export const PlanList = (props) => (
  <List {...props} filters={<PlanFilter/>}>
    <Datagrid rowClick="show">
      <TextField source="objectId"/>
      <TextField source="sku"/>
      <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
      <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
      <NumberField source="price"/>
        <TextField source="title"/>
        <NumberField source="duration"/>
      <BooleanField source="isDeleted"/>
    </Datagrid>
  </List>
);

export const PlanCreate = (props) => (
    <CreateView {...props}>
        <ReferenceInput label="نوع پلن" source="planTypeId" validate={required()} reference="planType">
            <SelectInput optionText="title"  alwaysOn/>
        </ReferenceInput>
        <TextInput source="sku" validate={required()}/>
        <NumberInput source="price" validate={required()}/>
        <TextInput source="title" validate={required()} />
        <Emoji source="description" label="توضیحات"/>
        <NumberInput source="duration" validate={required()}/>
        <BooleanInput source="isDeleted" defaultValue={false}/>
        <ImageInput source="pictures" label="تصویر مربوطه" accept="image/*">
            <ImageField source="src" title="title"/>
        </ImageInput>
        <TextInput source="label"/>
    </CreateView>
);


export const PlanEdit = (props) => {
    return (
        <EditView {...props}>
            <ReferenceInput label="نوع پلن" source="planTypeId" validate={required()} reference="planType">
                <SelectInput optionText="title"  alwaysOn/>
            </ReferenceInput>
            <TextInput source="sku" validate={required()}/>
            <NumberInput source="price" validate={required()}/>
            <TextInput source="title" validate={required()} />
            <Emoji source="description" label="توضیحات" />
            <NumberInput source="duration" validate={required()}/>
            <BooleanInput source="isDeleted" defaultValue={false}/>
            <ImageInput source="pictures"  label="تصویر مربوطه" accept="image/*">
                <ImageField source="src" title="title"/>
            </ImageInput>
            <TextInput source="label"/>
        </EditView>
    );
}

export const PlanShow = (props) => (
  <ShowView {...props}>
    <SimpleShowLayout>
        <TextField source="objectId"/>
        <TextField source="sku"/>
        <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
        <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
        <NumberField source="price"/>
        <ReferenceField link="show" label="نوع پلن" source="planTypeId" reference="planType" >
            <TextField source="title"/>
        </ReferenceField>
        <TextField source="title"/>
        <TextField source="description" />
        <NumberField source="duration"/>
        <BooleanField source="isDeleted"/>
        <TextField source="label"/>
        <ImageField source="icon"/>
    </SimpleShowLayout>
  </ShowView>
);
